import React from 'react';
import ProvidersManagement from '../components/Providers/ProvidersManagement';

export default function ProvidersPage() {
  return <ProvidersManagement />;
}
